import api from './api'
import { defActionSlice } from '../../../../helpers/defaultAction'
import { reObjectFunctionTypeReducer } from './reducer'

const { 
    setLoading,
    setError,
    getPagedSuccess,
    createSuccess,
    saveSuccess,
    getListSuccess,
    clear
} = reObjectFunctionTypeReducer.actions

export const getPagedAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getPagedSuccess,
        fail: setError,
        service: {
            func: api.getPaged,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getPagedAllAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getPagedSuccess,
        fail: setError,
        service: {
            func: api.getPagedAll,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getPagedAuditAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getPagedSuccess,
        fail: setError,
        service: {
            func: api.getPagedAudit,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getListAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: getListSuccess,
        fail: setError,
        service: {
            func: api.getList,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const deleteAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: saveSuccess,
        fail: setError,
        service: {
            func: api.delete,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const restoreAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: saveSuccess,
        fail: setError,
        service: {
            func: api.restore,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const createAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: createSuccess,
        fail: setError,
        service: {
            func: api.create,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const updateAction = (values) => {
    const defObj = {
        req: setLoading,
        suc: saveSuccess,
        fail: setError,
        service: {
            func: api.update,
            params: values
        }
    }
    return defActionSlice(defObj)
}

export const getObjectFuncTypes = (values) => {
	const defObj = {
		req: setLoading,
		suc: getListSuccess,
		fail: setError,
		service: {
			params: values,
			func: api.getObjFuncTypes
		}
	}
	return defActionSlice(defObj)
}

export const clearAction = (values) => {
	const defObj = {
		req: clear,
	}
	return defActionSlice(defObj)
}
